//@ts-nocheck
import chestNormal from '../other-textures/latest/entity/chest/christmas.png';
import chestDoubleLeft from '../other-textures/latest/entity/chest/christmas_left.png';
import chestDoubleRight from '../other-textures/latest/entity/chest/christmas_right.png';
export default {
    'entity/chest/normal': chestNormal,
    'entity/chest/normal_left': chestDoubleLeft,
    'entity/chest/normal_right': chestDoubleRight,
};
